export enum ShopifyCheckoutMode {
    Permalink = 'ShopifyPermalink',
    Cart = 'ShopifyCart',
}
